import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=c3a068e8&scoped=true"
import script from "./Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Register.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=c3a068e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a068e8",
  null
  
)

export default component.exports